import React from 'react';
import styled from 'styled-components';
import useIsDesktop from '@/src/hooks/useIsDesktopLayout';

const Card = styled.div`
  width: auto;
  padding: ${({ isDesktop }) => (isDesktop ? '16px' : '0')};
  background-color: rgb(255, 255, 255);
  height: 100%;
  margin: 0 16px;

  > div {
    margin-bottom: 32px;
  }
`;

const FormBody = ({ children }) => {
  const isDesktop = useIsDesktop();

  return (
    <Card withBorder={false} withShadow={isDesktop} isDesktop={isDesktop}>
      {children}
    </Card>
  );
};

export default FormBody;
